
if (!customElements.get('sticky-product-form')) {
  class StickyProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('.js-product-form');
      this.lastVariant = this.form.querySelector('[name="id"]').value;
      if (this.hasChildNodes()) this.init();
      this.dataType = this.getAttribute('data-type');
    }

    init() {
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        this.productInfo = document.querySelector('.product-info');
        const dataEl = this.productInfo.querySelector('.js-inventory-data');
        this.variantInventory = JSON.parse(dataEl.textContent);
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        const promoText = this.getAttribute('data-promo-text');
        if(promoText){
          const nums = promoText.match(/\d+/g);
          if(nums && nums.length > 1){
            this.setAttribute('data-promo-value', nums[0]);
            this.promoValue = parseInt(nums[0], 10);
            this.addExtraValue = parseInt(nums[1], 10);
          }
        }
        this.checkQuantityAtLocation();
        this.applyNoLocationCommerceState();
        if(this.productInfo.dataset.inventoryPolicy !== "continue") this.observeVariantChanges();
      }
    }

    observeVariantChanges() {
      const observer = new MutationObserver(() => {
        const currentVariant = this.form.querySelector('[name="id"]').value;
        if (currentVariant !== this.lastVariant) {
          this.lastVariant = currentVariant;
          if(this.productInfo.dataset.inventoryPolicy !== "continue") this.checkQuantityAtLocation();
        }
      });
  
      const productInfo = document.querySelector(".sticky-atc-panel");
      observer.observe(productInfo, { childList: true, subtree: true });
    }

    /**
     * Handles 'change' events on the quantity-input element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.value);
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }
      
      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      // Get all quick order lists on the page
      const quickOrderSections = [];
      document.querySelectorAll('quick-order-list').forEach((quickOrderList) => {
        const closestSection = quickOrderList.closest('.shopify-section');
        if (closestSection) {
          const sectionId = closestSection.id.replace('shopify-section-', '');
          // sections.push({
          //   id: `quick-order-list_${sectionId}`,
          //   section: sectionId,
          //   selector: `#quick-order-list_${sectionId}`
          // });
          sections += `,${sectionId}`;
        }
      });

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);
      
      let preferred = null;
      try {
        const storedPreferred = localStorage.getItem('preferredLocation');
        const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;
        if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
          preferred = parsedPreferred;
        }
      } catch (error) {
        preferred = null;
      }

      if (!preferred) {
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');
        this.openLocationSelector();
        return;
      }

      if(this.productInfo.getAttribute('data-inventory-policy') !== 'continue'){
        const title = document.querySelector('.product-title').textContent?.trim();
        let variantText = '';
        const ProductVariants = this.querySelectorAll('variant-picker button');
        ProductVariants.forEach((v, idx) => {
            variantText += ( idx === 0 ? '' : ' / ') + v.dataset.value ;
        });
        const errMsg = `You can't add more ${title} - ${variantText} to the cart.`;
        let selectedQuantity = this.dataType === 'promo' ? this.promoValue : 1;

        const checkedQuantity = this.checkQuantityAtLocation(errMsg, true);
        if(checkedQuantity == null) return;
        const { totalQuantity, productStock, inCartQuantity } = checkedQuantity;
        if(totalQuantity > productStock) {
          selectedQuantity = productStock - inCartQuantity;
          // console.log('should be selected quantity', selectedQuantity)
          formData.append('quantity', selectedQuantity);
        } else {
          // console.log('selected quantity', selectedQuantity)
          formData.append('quantity', selectedQuantity);
        }

        stock.reduce((acc, store) => {
          const id = store.locationId.split('/').pop();
            acc[id] = store.stock;
            formData.append(`properties[_prevInventory][${id}]`, store.stock);
            return acc;
        }, {});
      }
      if(this.dataType === 'promo' && this.productInfo.getAttribute('data-inventory-policy') === 'continue'){
        // console.log('within data type and continue policy')
        formData.append('quantity', this.promoValue);
      }
      // console.log('after update', Object.fromEntries(formData));

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        // if(totalQuantity > productStock) {
        //   this.setErrorMsgState(errMsg);
        // }

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          StickyProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && ((theme.settings.afterAtc === 'drawer_desktop' && theme.mediaMatches.md)
                  || theme.settings.afterAtc === 'drawer')
              );

              // Update the quick order lists on the page
              if (quickOrderSections.length) {
                quickOrderSections.forEach((quickOrderSection) => {
                  const sectionEl = document.getElementById(quickOrderSection.id);
                  if (!sectionEl) return;

                  const el = sectionEl.querySelector(quickOrderSection.selector) || sectionEl;
                  el.innerHTML = StickyProductForm.getElementHTML(
                    data.sections[quickOrderSection.section],
                    quickOrderSection.selector
                  );
                });
              }
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refreshCartItems();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        let newQuantity = 1;

        // Check if product was already in the cart
        if (itemInOldCart) {
          newQuantity = (itemInOldCart.quantity === data.quantity)
            ? itemInOldCart.quantity : data.quantity;
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));

          // Update the quantity selectors if needed
          if (this.quantitySelector) {
            this.setAttribute('data-show-quantity-selector', 'true');
            this.quantityInput.value = newQuantity;
            this.quantitySelector.currentQty = this.quantityInput.dataset.initialValue;
          }
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refreshCartDrawer();
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    applyNoLocationCommerceState(attempt = 0) {
      let preferred = null;

      try {
        const storedPreferred = localStorage.getItem('preferredLocation');
        const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

        if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
          preferred = parsedPreferred;
        }
      } catch (error) {
        preferred = null;
      }

      if (preferred) return;

      const buttonText = this.submitBtn?.textContent?.trim() || '';
      const stillSettling = !window.stock || buttonText === 'SOLD OUT' || this.submitBtn?.disabled;

      if (stillSettling && attempt < 20) {
        setTimeout(() => this.applyNoLocationCommerceState(attempt + 1), 100);
      }

      if (!this.submitBtn) return;

      this.submitBtn.disabled = false;
      this.submitBtn.setAttribute('aria-disabled', 'false');

      if (this.submitBtn.getAttribute('data-type') !== 'promo' && this.submitBtn.textContent.trim() === 'SOLD OUT') {
        this.submitBtn.textContent = 'ADD TO CART';
      }
    }

    openLocationSelector() {
      const selector = document.querySelector('state-popup');
      if (!selector) return false;

      if (typeof selector.openPopup === 'function') {
        selector.openPopup();
        return true;
      }

      if (typeof selector.togglePopup === 'function') {
        selector.togglePopup();
        return true;
      }

      return false;
    }

    checkQuantityAtLocation(msg = null, openSelector = false){
      let preferred = null;

      try {
        const storedPreferred = localStorage.getItem('preferredLocation');
        const parsedPreferred = storedPreferred ? JSON.parse(storedPreferred) : null;

        if (parsedPreferred && typeof parsedPreferred === 'object' && parsedPreferred.id) {
          preferred = parsedPreferred;
        }
      } catch (error) {
        preferred = null;
      }

      if (!preferred) {
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');
        if (openSelector) this.openLocationSelector();
        return null;
      }

      if (!window.stock) {
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');
        return null;
      }

      let inCartQuantity = 0;
      let newTotalQuantity = this.dataType === 'promo' ? this.promoValue : 1;
      const productStock = window.stock.find(item => {
        if (!item?.locationId) return false;
        const id = item.locationId.split('/').pop();
        return id === preferred.id;
      });

      if (!productStock) {
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');
        return null;
      }

      if(this.dataType === 'promo'){
        const lowStock = productStock.stock < newTotalQuantity;
        if(lowStock){
          this.setErrorMsgState("Please check product availability before proceeding with your order.");
          this.submitBtn.removeAttribute('aria-disabled');
          this.submitBtn.classList.remove('is-loading');
          return null;
        }
      }
      // console.log('newTotalQuantity:', newTotalQuantity);
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.querySelectorAll('.cart-item').forEach((item) => {
          if(item.dataset.variantId === this.lastVariant){
            inCartQuantity = Number(item.querySelector('.qty-input__input').value);
            newTotalQuantity+=inCartQuantity;
          };
        });
      }
      // console.log('inCartQuantity:', inCartQuantity);
      if(inCartQuantity >= productStock.stock){
        if(msg) this.setErrorMsgState(msg);
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.classList.remove('is-loading');
        const buyBtns = document.querySelectorAll('.product-info__add-button button');
        buyBtns.forEach(btn => btn.disabled = true);
        return null;
      }
      return {totalQuantity: newTotalQuantity, productStock: productStock.stock, inCartQuantity }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || document.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('sticky-product-form', StickyProductForm);
}
